import { computed, Injectable, signal } from '@angular/core';

import { UserInfo } from '../../proxy/models/common';
import { UserType } from '../global/constants/constant';

@Injectable({
  providedIn: 'root',
})
export class UserInfoService {
  private _userInfo = signal<UserInfo | null>(null);

  public readonly userInfo = this._userInfo.asReadonly();

  public readonly userType = computed<UserType | null>(() => {
    const user = this._userInfo();
    return user ? user.userType : null;
  });

  public saveUserInfo(user: UserInfo): void {
    this._userInfo.set(user);
  }

  public removeUserInfo(): void {
    this._userInfo.set(null);
  }
}
